export async function enableMocking(): Promise<void> {
  if (import.meta.env.MODE !== 'development') return;

  if (import.meta.env.VITE_ENABLE_MOCKS !== 'true') return;

  const { worker } = await import('./browser');

  await worker.start({
    onUnhandledRequest: 'bypass',
  });
}
